import { FC, memo } from "react";
import styled from "styled-components";
import { transparentize } from "polished";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Timer from "../_shared/Timer";
import { IWorkItem } from "../../../models/BlenderAgentStateModel";
import { getMediaColor } from "../../../style/theme";

interface IProps {
  workItem: IWorkItem;
}

const iconSize = "2.5rem";

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.primary};
  overflow: hidden;
`;

const OuterCircle = styled.div<{ color: string }>`
  width: 19rem;
  height: 19rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  flex-shrink: 0;
  border: 0.9rem solid ${(props) => transparentize(0.7, props.color)};
`;

const InnerCircle = styled.div<{ color: string }>`
  width: 16rem;
  height: 16rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  flex-shrink: 0;
  border: 1rem solid ${(props) => props.color};
`;

const CallDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const MainText = styled.div`
  font-size: 2rem;
  line-height: 1;
  font-weight: 600;
`;

const TimerContainer = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
`;

const VoiceConversationWindow: FC<IProps> = memo(({ workItem }) => {
  const color = getMediaColor(workItem.primaryMediaType,workItem.primaryChannelType);
  return (
    <RootContainer>
      <OuterCircle color={color}>
        <InnerCircle color={color}>
          <CallDetailsContainer>
            <FontAwesomeIcon
              icon={faPhone}
              style={{ width: iconSize, height: iconSize }}
              color={color}
            />
            <TextContainer>
              <MainText>In Call</MainText>
              <TimerContainer>
                <Timer date={workItem.createdAt} />
              </TimerContainer>
            </TextContainer>
          </CallDetailsContainer>
        </InnerCircle>
      </OuterCircle>
    </RootContainer>
  );
});

export default VoiceConversationWindow;
